import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'white' | 'light';
}

export function Section({ children, className = '', background = 'white' }: SectionProps) {
  const bgColor = background === 'light' ? 'bg-[#F8F5F1]' : 'bg-white';
  
  return (
    <section className={`py-20 ${bgColor} ${className}`}>
      {children}
    </section>
  );
}